import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { customStorage } from './utils';
import Config from '@/config';
import { AppVersion, GenericState } from '@/types';
import { LanguageCode } from '@ygoargentina/sdk/api/api.types';

export type LayoutState = GenericState & {
  visibleAside: boolean;
  isCollapsed: boolean;
  language: LanguageCode;

  toggleAside: (newState?: boolean) => void;
  setIsCollapsed: (newState: boolean) => void;
  setLanguage: (language: LanguageCode) => void;
};

export const layoutInitialState = {
  language: LanguageCode.English,
  visibleAside: false,
  isCollapsed: true,
};

export const useLayoutStore = create<
  LayoutState,
  [['zustand/devtools', never], ['zustand/persist', LayoutState]]
>(
  devtools(
    persist(
      (set) => ({
        ...layoutInitialState,

        setIsCollapsed: (newState: boolean) =>
          set((state) => ({
            ...state,
            isCollapsed: newState,
          })),
        toggleAside: (newState?: boolean) =>
          set((state) => ({
            ...state,
            visibleAside: newState ?? !state.visibleAside,
          })),
        setLanguage: (lang: LanguageCode) =>
          set((state) => ({
            ...state,
            language: lang,
          })),
        resetStore: () => set(() => layoutInitialState),
      }),
      {
        name: `${Config.sessionKey}-layout@${AppVersion}`,
        storage: createJSONStorage<LayoutState>(() => customStorage),
      }
    )
  )
);
